export const notificationMessages = {
    notificationHeader: {
        key: 'global.labelsAndTitles.NOTIFICATION_HEADER'
    },
    noData: {
        key: 'global.messages.NO_DATA'
    }
};